import { combineReducers } from 'redux';
const pattern: any = /^\.\/([a-z]+)\/index\.ts$/i;

const modules = require.context('./', true, /^\.\/([a-z]+)\/index\.ts$/i);

const addReducer = (reducer, name) => ({
  [name]: typeof reducer === 'function' ? reducer : combineReducers(reducer),
});

export default modules.keys().reduce((acc: any, key: string) => {
  const name = pattern.exec(key)[1];
  const apiModule: any = modules(key) ;
  const _module = apiModule.default || apiModule;
  
  return {
    sagas: _module.saga
      ? [...acc.sagas, ..._module.saga]
      : acc.sagas,
    reducers: _module.reducer
      ? { ...acc.reducers, ...addReducer(_module.reducer, name) }
      : acc.reducers
  };
}, { sagas: [], reducers: {} });
